import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
} from '@angular/core';

import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { ControlValueAccessorConnector } from '../utils/control-value-accessor-connector/control-value-accessor-connector';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'stena-keypad',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => StenaKeypadComponent),
      multi: true,
    },
  ],
  imports: [MatInputModule, MatButtonModule, MatIconModule],
  templateUrl: './stena-keypad.component.html',
  styleUrls: ['./stena-keypad.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StenaKeypadComponent
  extends ControlValueAccessorConnector
  implements OnInit
{
  @Input() label? = '';
  @Input() amount? = '';
  @Output() afterConfirmation: EventEmitter<any> = new EventEmitter();

  currentAmount = '';

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.currentAmount = this.amount && this.amount !== '0' ? this.amount : '';
  }

  addNumber(selectedNumber: string) {
    if (this.currentAmount.length < 15) {
      this.currentAmount += selectedNumber;
    }
  }

  removeLatest() {
    this.currentAmount = this.currentAmount.substring(
      0,
      this.currentAmount.length - 1
    );
  }

  confirm() {
    if (this.afterConfirmation) {
      this.afterConfirmation.emit(this.currentAmount);
    }
    this.currentAmount = '';
  }
}
